/**
 * Created by rickborst on 24/04/2017.
 */

import _ from 'lodash';

import {ViewNames} from 'models/view';
import {ProgramTypes} from 'models/asset';

const ViewNamesMap = {
    'Dashboard': ViewNames.DASHBOARD,
    'Collection': ViewNames.COLLECTION,
    'Search': ViewNames.SEARCH,
    'Player': ViewNames.PLAYER,
    'Discover': ViewNames.DISCOVER,
    'Quickgrid': ViewNames.MINI_EPG,
    'Grid': ViewNames.EPG
};

import {convertFromReadRail} from './rails';

/**
 * Parse the response from get view request.
 *
 * @param {Object} data - Response data.
 * @returns {Object} View data.
 */
function convertFromReadView (data) {
    let views = {};

    _.forEach(_.map(data.childCategories || [], convertFromReadView.bind(this)),
        view => {
            views[view.id] = view;
        });

    return {
        id: data.id,
        name: ViewNamesMap[data.name] || data.name,
        images: data.images || [],
        modules: _.map(data.channels || [], convertFromReadRail.bind(this)),
        views: views,
        apiSpecifics: {
            parentId: data.parentCategoryId || '',
            objectType: data.objectType || ''
        }
    };
}

/**
 * Convert request data to Kaltura's naming.
 *
 * @param {string} [id] - Category id.
 * @returns {Object} Transformed data.
 */
function convertForFetchViews (id) {

    return {
        id: id || this._presets.mainViewsId || ''
    };
}

/**
 * Parse the response from fetch views request.
 *
 * @param {Object} data - Response data.
 * @returns {Array} Views data.
 */
function convertFromFetchViews (data) {
    let rawViews = _.get(data, ['result', 'childCategories']) || [];

    return _.map(rawViews, convertFromReadView.bind(this));
}

/**
 * Returns a collection name based on a given asset.
 *
 * @param {Object} asset - Asset object.
 * @returns {string} Collection name.
 */
function convertAssetToCollectionName (asset) {
    let programType = asset.programType || '',
        sportType = asset.matchInfo.sportType || '';

    if (programType === ProgramTypes.MATCH) {

        switch (sportType) {

            case 'soccer':
                return 'root.collection.match.soccer';

            case 'basketball':
                return 'root.collection.match.basketball';

            case 'volleyball':
                return 'root.collection.match.volleyball';

            case 'tennis':
                return 'root.collection.match.tennis';

            case 'handball':
                return 'root.collection.match.handball';

            case 'motorsport':
                return 'root.collection.match.motorsport';

            case 'other':
            default:
                return 'root.collection.match.other';
        }
    }

    switch (programType) {

        case ProgramTypes.DOCUMENTARY:
            return 'root.collection.documentary';

        case ProgramTypes.NEWS:
            return 'root.collection.news';


        case ProgramTypes.MAGAZINE:
            return 'root.collection.magazine';

        case ProgramTypes.RECAP:
            return 'root.collection.recap';

        case ProgramTypes.ORIGINAL:
        default:
            return 'root.collection.original';
    }
}

/**
 * Converts an asset to a discover name.
 *
 * @param {Object} asset - Asset object.
 * @returns {string} Discover name.
 */
function convertAssetToDiscoverName (asset) {

    return asset.description;
}

export {
    convertFromReadView,
    convertForFetchViews,
    convertFromFetchViews,
    convertAssetToCollectionName,
    convertAssetToDiscoverName
};



// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/views.js